import React, { FC, useCallback } from "react";
import Link from "../../../ActionsSelectors/Link/Link";
import ProductPrice, {
  onlyMainPrices,
} from "../../../DataDisplay/Price/ProductPrice";
import { ProductWithLink } from "./SearchResults.interface";
import { Image } from "../../../Utility/MediaBuilder/Image";

export interface ISearchResultsWithDetailsProps {
  item: ProductWithLink;
  onSearchResultClick?(item: ProductWithLink);
}

const SearchResultsWithDetails: FC<ISearchResultsWithDetailsProps> = ({
  item,
  onSearchResultClick,
}) => {
  const {
    itemName,
    brand,
    category,
    prices,
    image,
    imageAlt,
    link = "/",
  } = item;

  const clickHandler = useCallback(
    () => onSearchResultClick?.(item),
    [item, onSearchResultClick],
  );

  const mainPrices = onlyMainPrices(prices);

  return (
    <Link
      href={link}
      classes={{
        root: "product-card__suggestions d-inline-flex col-12 col-12 col-md-6 mb-7",
      }}
      onClick={clickHandler}
    >
      <figure>
        <Image src={image} alt={imageAlt} />
        <figcaption>
          <div className="product-intro">
            <div className="product-title">
              <div className="product-brand">{brand}</div>
              <div className="product-model">{itemName}</div>
            </div>
            <div className="product-category">{category}</div>
          </div>
          <div className="product-numbers">
            <ProductPrice prices={mainPrices} theme="dark" />
          </div>
        </figcaption>
      </figure>
    </Link>
  );
};

export default SearchResultsWithDetails;
